import type { FaireProductEntity } from "../../entity_types/product";

export const p_czd74qe6wf: FaireProductEntity = {
  token: "p_czd74qe6wf",
  type: "product",
  name: "Mini Radiant Initial Necklace",
  brandToken: "b_6t4mvvvp2x",
  brandName: "The Sis Kiss",
  imageUrl:
    "https://cdn.faire.com/fastly/a84673fb0ef2a850edb16693d3000438a091ab296f3c43ae7f67a9a3d6a7becc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5679217589e42b0057c6847eb116f1bc06110dd4604f7dfe298b2cfb1553f62.jpeg",
    "https://cdn.faire.com/fastly/a86b290a3cf3f14f897430eef7e212ae5b3321b620786804e1062cf0679a02b4.jpeg",
    "https://cdn.faire.com/fastly/b60bf4111f431cc7c7121e03df2ad77c6627f33d4c20bdcc4c3ddf188043ac2e.jpeg",
    "https://cdn.faire.com/fastly/cd6460c7c1cd86118ecce8fe91916c53fe540f20d9a33a0807042bd5d5f8f0d8.jpeg",
    "https://cdn.faire.com/fastly/c9a626fde05f460f86837017316e8631019a605dab7096113a21be9aae1592d6.jpeg",
    "https://cdn.faire.com/fastly/7cd5a33d95395f8b1442568b9aecf8cdbf44d52dd8bba94988ddd96c9a42ccf4.jpeg",
    "https://cdn.faire.com/fastly/151d7d1d090988ef7cc5bcef497806d79f502b491542c0b209217f4aded10e57.jpeg",
    "https://cdn.faire.com/fastly/026eab8fc478e3b6d0e72793a914bb8145ec3da08c3e3aa4a09f242b00f01959.jpeg",
    "https://cdn.faire.com/fastly/6243decaa99a08ead7fac882dffd340f028d784b0c3a8d0f7e1b2543685dafd9.jpeg",
    "https://cdn.faire.com/fastly/ee320dd38ed0d75947480adf8374646d03ed3478ac6285ed9b4b521642c88299.jpeg",
  ],
  priceDollars: 17,
  description:
    'Any initial surrounded by a circular crystal design that shines! We love it and your customers will too! \n\nDetails: \n\nMaterial: 18k gold plated brass with crystals\nLength: 16" with 2" extension \nPendant Initial: 1/2" in diameter ',
  tags: [],
  msrpDollars: 37.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:40.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
